import { useNavigate } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { isAdminOrStaffRole, isMemberRole } from "../../utils/roles";

const pathParts = window.location.pathname.split("/").filter(Boolean);
const tenantId = pathParts[0] || null;

export default function AccessDenied() {
  const { isDarkMode } = useTheme();
  const userRole = localStorage.getItem("userRole");
  const navigate = useNavigate();

  const handelDashboard = () => {
    if (isAdminOrStaffRole(userRole)) {
      navigate(`/${tenantId}/manage/memberships`);
      return;
    } else if (isMemberRole(userRole)) {
      navigate(`/${tenantId}/dashboard`);
      return;
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center h-screen text-center ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <h1 className={`text-3xl font-bold ${isDarkMode ? 'text-red-400' : 'text-red-600'}`}>🚫 Access Denied</h1>
      <p className={`mt-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
        You do not have permission to view this page.
      </p>
      <button
        onClick={handelDashboard}
        className="mt-4 px-4 py-2 bg-[var(--cc-action)] text-[var(--cc-action-text)] hover:bg-[var(--cc-action-hover)] rounded transition-colors"
      >
        Back to Dashboard
      </button>
    </div>
  );
}
